import { render, staticRenderFns } from "./oumeibookth.vue?vue&type=template&id=2b164613&scoped=true&"
import script from "./oumeibookth.vue?vue&type=script&lang=js&"
export * from "./oumeibookth.vue?vue&type=script&lang=js&"
import style0 from "./oumeibookth.vue?vue&type=style&index=0&id=2b164613&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b164613",
  null
  
)

export default component.exports